import { AssetManager } from '../../../../../viewer/asset-manager';
import { InputHandler } from '../../../../../viewer/input-handler';
import {
  getTransformModeFreezeKey,
  TransformMode,
} from '../../../../../viewer/tools/transform-tool';

export const transformState = (transformMode: TransformMode) => {
  const freezeKey = getTransformModeFreezeKey(transformMode);
  const asset = AssetManager.instance.getSelected();
  return !asset || !asset.selected || asset.freeze[freezeKey];
};

export const transformMode = (transformMode: TransformMode) => {
  const transformActive = InputHandler.instance.isTransformToolActive();
  if (!transformActive) {
    return false;
  }

  const freezeKey = getTransformModeFreezeKey(transformMode);
  const selected = AssetManager.instance.getSelected();
  const isDisabled = selected && selected.freeze[freezeKey];

  return isDisabled
    ? false
    : transformActive && InputHandler.instance.getTransformMode() === transformMode;
};
